/**
 * Counts the disjunctions a built `where` array costs Firestore.
 *
 * Firestore expands a query into disjunctive normal form, so list-valued clauses
 * multiply rather than add: an `in` of 6 types with an `array-contains-any` of 5
 * subscribers is 30 disjunctions, not 11. A clause whose value is a single scalar
 * contributes one factor and so leaves the product unchanged.
 *
 * Consumed by `useHomePageOrchestrator`, which measures the `where` array it is about
 * to send against `FIRESTORE_MAX_DISJUNCTIONS` and refuses to run an over-budget query.
 */
import type { ListFormVersionsDocsRequest } from '#types';

export function countWhereDisjunctions(
  where: NonNullable<ListFormVersionsDocsRequest['where']>,
): number {
  return where.reduce(
    (product, clause) => product * (Array.isArray(clause.value) ? clause.value.length : 1),
    1,
  );
}
